import { render } from "./CostStandardsArchive.vue?vue&type=template&id=f6676e06&scoped=true&ts=true"
import script from "./CostStandardsArchive.vue?vue&type=script&lang=ts"
export * from "./CostStandardsArchive.vue?vue&type=script&lang=ts"

import "./CostStandardsArchive.vue?vue&type=style&index=0&id=f6676e06&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6676e06"]])

export default __exports__